import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "serviceBattery"
const ServiceBatteryIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg
      fillRule="evenodd"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="m9 2h-3v2h3zm9 0h-3v2h3zm-15 6h-1v-3h20v3h-1v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2-2zm11.464 5.215a.248.248 0 0 1 .187.38l-3.476 5.462c-.147.231-.504.09-.453-.179l.743-3.952-2.508-.224a.248.248 0 0 1 -.187-.38l3.476-5.462c.145-.228.498-.093.454.173l-.652 3.958z"
      />
    </svg>
  )
}
export default ServiceBatteryIcon
